import { render, staticRenderFns } from "./cartTab.vue?vue&type=template&id=4afb5e18&scoped=true&"
import script from "./cartTab.vue?vue&type=script&lang=js&"
export * from "./cartTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb5e18",
  null
  
)

export default component.exports